/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { ChangePatientStatusRequest } from '../models/ChangePatientStatusRequest';
import type { CreatePatientRequest } from '../models/CreatePatientRequest';
import type { GetPatientDetailedByIdResponse } from '../models/GetPatientDetailedByIdResponse';
import type { GetPatientEditRequestComparisonResponse } from '../models/GetPatientEditRequestComparisonResponse';
import type { GetPatientEventLogsResponse } from '../models/GetPatientEventLogsResponse';
import type { GetPatientOverviewResponse } from '../models/GetPatientOverviewResponse';
import type { GetPatientProviderAccountStatusResponse } from '../models/GetPatientProviderAccountStatusResponse';
import type { GetPatientRequestsResponse } from '../models/GetPatientRequestsResponse';
import type { GetPatientSummariesResponse } from '../models/GetPatientSummariesResponse';
import type { GetPaymentProviderCountryCurrenciesResponse } from '../models/GetPaymentProviderCountryCurrenciesResponse';
import type { ISaveStatus } from '../models/ISaveStatus';
import type { PatientBaseStudyDetailsResponse } from '../models/PatientBaseStudyDetailsResponse';
import type { TransferToAnotherSiteRequest } from '../models/TransferToAnotherSiteRequest';
import type { UpdatePatientAdditionalInformationRequest } from '../models/UpdatePatientAdditionalInformationRequest';
import type { UpdatePatientAdditionalInformationResponse } from '../models/UpdatePatientAdditionalInformationResponse';
import type { UpdatePatientCaregiversRequest } from '../models/UpdatePatientCaregiversRequest';
import type { UpdatePatientCaregiversResponse } from '../models/UpdatePatientCaregiversResponse';
import type { UpdatePatientConsentRequest } from '../models/UpdatePatientConsentRequest';
import type { UpdatePatientConsentResponse } from '../models/UpdatePatientConsentResponse';
import type { UpdatePatientFromEditRequestRequest } from '../models/UpdatePatientFromEditRequestRequest';
import type { UpdatePatientNotesRequest } from '../models/UpdatePatientNotesRequest';
import type { UpdatePatientNotesResponse } from '../models/UpdatePatientNotesResponse';
import type { UpdatePatientPaymentDetailsRequest } from '../models/UpdatePatientPaymentDetailsRequest';
import type { UpdatePatientPaymentDetailsResponse } from '../models/UpdatePatientPaymentDetailsResponse';
import type { UpdatePatientPersonalInfoRequest } from '../models/UpdatePatientPersonalInfoRequest';
import type { UpdatePatientPersonalInfoResponse } from '../models/UpdatePatientPersonalInfoResponse';
import type { UpdatePatientSingleNoteRequest } from '../models/UpdatePatientSingleNoteRequest';
import type { UpdatePatientSingleNoteResponse } from '../models/UpdatePatientSingleNoteResponse';
import type { UpdatePatientTravelInformationRequest } from '../models/UpdatePatientTravelInformationRequest';
import type { UpdatePatientTravelInformationResponse } from '../models/UpdatePatientTravelInformationResponse';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class PatientControllerv2Service {
    constructor(public readonly http: HttpClient) {}
    /**
     * @returns GetPatientSummariesResponse
     * @throws ApiError
     */
    public patientControllerv2GetPatientSummaries(): Observable<Array<GetPatientSummariesResponse>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/patients/summaries',
        });
    }
    /**
     * @param patientId
     * @returns GetPatientEditRequestComparisonResponse
     * @throws ApiError
     */
    public patientControllerv2GetPatientEditRequestComparison(
        patientId: number,
    ): Observable<GetPatientEditRequestComparisonResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/patients/{patientId}/edit-request-compare',
            path: {
                'patientId': patientId,
            },
        });
    }
    /**
     * @param patientId
     * @param requestBody
     * @returns number
     * @throws ApiError
     */
    public patientControllerv2UpdatePatientFromEditRequest(
        patientId: number,
        requestBody: UpdatePatientFromEditRequestRequest,
    ): Observable<number> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/v2/patients/{patientId}/edit-request',
            path: {
                'patientId': patientId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param patientId
     * @returns GetPatientOverviewResponse
     * @throws ApiError
     */
    public patientControllerv2GetPatientOverview(
        patientId: number,
    ): Observable<GetPatientOverviewResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/patients/{patientId}/overview',
            path: {
                'patientId': patientId,
            },
        });
    }
    /**
     * @param patientId
     * @returns GetPatientRequestsResponse
     * @throws ApiError
     */
    public patientControllerv2GetPatientRequests(
        patientId: number,
    ): Observable<GetPatientRequestsResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/patients/{patientId}/requests',
            path: {
                'patientId': patientId,
            },
        });
    }
    /**
     * @param patientId
     * @param requestBody
     * @returns binary
     * @throws ApiError
     */
    public patientControllerv2TransferToAnotherSite(
        patientId: number,
        requestBody: TransferToAnotherSiteRequest,
    ): Observable<Blob> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/v2/patients/{patientId}/transfer-to-another-site',
            path: {
                'patientId': patientId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param patientId
     * @param kycDocumentId
     * @returns binary
     * @throws ApiError
     */
    public patientControllerv2GetPatientKycDocument(
        patientId: number,
        kycDocumentId: number,
    ): Observable<Blob> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/patients/{patientId}/kyc/{kycDocumentId}',
            path: {
                'patientId': patientId,
                'kycDocumentId': kycDocumentId,
            },
        });
    }
    /**
     * @param patientId
     * @param kycDocumentId
     * @returns ISaveStatus
     * @throws ApiError
     */
    public patientControllerv2DeletePatientKycDocument(
        patientId: number,
        kycDocumentId: number,
    ): Observable<ISaveStatus> {
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/api/v2/patients/{patientId}/kyc/{kycDocumentId}',
            path: {
                'patientId': patientId,
                'kycDocumentId': kycDocumentId,
            },
        });
    }
    /**
     * @param patientId
     * @param requestBody
     * @returns binary
     * @throws ApiError
     */
    public patientControllerv2ChangePatientStatus(
        patientId: number,
        requestBody: ChangePatientStatusRequest,
    ): Observable<Blob> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/v2/patients/{patientId}/change-status',
            path: {
                'patientId': patientId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param patientId
     * @param requestBody
     * @returns UpdatePatientConsentResponse
     * @throws ApiError
     */
    public patientControllerv2UpdatePatientConsent(
        patientId: number,
        requestBody: UpdatePatientConsentRequest,
    ): Observable<UpdatePatientConsentResponse> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/v2/patients/{patientId}/consent',
            path: {
                'patientId': patientId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param patientId
     * @param requestBody
     * @returns UpdatePatientPersonalInfoResponse
     * @throws ApiError
     */
    public patientControllerv2UpdatePatientPersonalInfo(
        patientId: number,
        requestBody: UpdatePatientPersonalInfoRequest,
    ): Observable<UpdatePatientPersonalInfoResponse> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/v2/patients/{patientId}/personal-info',
            path: {
                'patientId': patientId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param patientId
     * @param requestBody
     * @returns UpdatePatientTravelInformationResponse
     * @throws ApiError
     */
    public patientControllerv2UpdatePatientTravelInformation(
        patientId: number,
        requestBody: UpdatePatientTravelInformationRequest,
    ): Observable<UpdatePatientTravelInformationResponse> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/v2/patients/{patientId}/travel-info',
            path: {
                'patientId': patientId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param patientId
     * @param formData
     * @returns UpdatePatientPaymentDetailsResponse
     * @throws ApiError
     */
    public patientControllerv2UpdatePatientPaymentDetails(
        patientId: number,
        formData?: UpdatePatientPaymentDetailsRequest,
    ): Observable<UpdatePatientPaymentDetailsResponse> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/v2/patients/{patientId}/payment-details',
            path: {
                'patientId': patientId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * @param patientId
     * @param requestBody
     * @returns UpdatePatientAdditionalInformationResponse
     * @throws ApiError
     */
    public patientControllerv2UpdatePatientAdditionalInformation(
        patientId: number,
        requestBody: UpdatePatientAdditionalInformationRequest,
    ): Observable<UpdatePatientAdditionalInformationResponse> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/v2/patients/{patientId}/additional-info',
            path: {
                'patientId': patientId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param patientId
     * @param requestBody
     * @returns UpdatePatientNotesResponse
     * @throws ApiError
     */
    public patientControllerv2UpdatePatientNotes(
        patientId: number,
        requestBody: UpdatePatientNotesRequest,
    ): Observable<UpdatePatientNotesResponse> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/v2/patients/{patientId}/notes',
            path: {
                'patientId': patientId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param patientId
     * @param requestBody
     * @returns UpdatePatientCaregiversResponse
     * @throws ApiError
     */
    public patientControllerv2UpdatePatientCaregivers(
        patientId: number,
        requestBody: UpdatePatientCaregiversRequest,
    ): Observable<UpdatePatientCaregiversResponse> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/v2/patients/{patientId}/caregivers',
            path: {
                'patientId': patientId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param caregiverIds
     * @returns string
     * @throws ApiError
     */
    public patientControllerv2GetCaregiverDeletionBlockers(
        caregiverIds?: Array<number> | null,
    ): Observable<Record<string, Array<string>>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/patients/caregivers/can-delete',
            query: {
                'caregiverIds': caregiverIds,
            },
        });
    }
    /**
     * @param patientId
     * @param patientNoteId
     * @param requestBody
     * @returns UpdatePatientSingleNoteResponse
     * @throws ApiError
     */
    public patientControllerv2UpdatePatientSingleNote(
        patientId: number,
        patientNoteId: number,
        requestBody: UpdatePatientSingleNoteRequest,
    ): Observable<UpdatePatientSingleNoteResponse> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/v2/patients/{patientId}/notes/{patientNoteId}',
            path: {
                'patientId': patientId,
                'patientNoteId': patientNoteId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param formData
     * @returns number
     * @throws ApiError
     */
    public patientControllerv2CreatePatient(
        formData?: CreatePatientRequest,
    ): Observable<number> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/v2/patients',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * @param patientId
     * @returns GetPatientDetailedByIdResponse
     * @throws ApiError
     */
    public patientControllerv2GetPatientDetailedById(
        patientId: number,
    ): Observable<GetPatientDetailedByIdResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/patients/{patientId}',
            path: {
                'patientId': patientId,
            },
        });
    }
    /**
     * @param patientId
     * @param reason
     * @returns binary
     * @throws ApiError
     */
    public patientControllerv2DeletePatient(
        patientId: number,
        reason?: string | null,
    ): Observable<Blob> {
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/api/v2/patients/{patientId}',
            path: {
                'patientId': patientId,
            },
            query: {
                'reason': reason,
            },
        });
    }
    /**
     * @param siteId
     * @returns PatientBaseStudyDetailsResponse
     * @throws ApiError
     */
    public patientControllerv2GetSiteStudyDetails(
        siteId?: number,
    ): Observable<PatientBaseStudyDetailsResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/patients/site-study-details',
            query: {
                'siteId': siteId,
            },
        });
    }
    /**
     * @param patientId
     * @returns GetPatientProviderAccountStatusResponse
     * @throws ApiError
     */
    public patientControllerv2GetPatientProviderAccountStatus(
        patientId: number,
    ): Observable<GetPatientProviderAccountStatusResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/patients/{patientId}/pq-account-status',
            path: {
                'patientId': patientId,
            },
        });
    }
    /**
     * @param patientId
     * @returns GetPatientProviderAccountStatusResponse
     * @throws ApiError
     */
    public patientControllerv2SendPayQuickerInvitationReminder(
        patientId: number,
    ): Observable<GetPatientProviderAccountStatusResponse> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/v2/patients/{patientId}/send-pq-invitation-reminder',
            path: {
                'patientId': patientId,
            },
        });
    }
    /**
     * @param countryCodes
     * @returns GetPaymentProviderCountryCurrenciesResponse
     * @throws ApiError
     */
    public patientControllerv2GetPaymentProviderCountryCurrencies(
        countryCodes?: Array<string> | null,
    ): Observable<Array<GetPaymentProviderCountryCurrenciesResponse>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/patients/payment-provider-country-currencies',
            query: {
                'countryCodes': countryCodes,
            },
        });
    }
    /**
     * @param patientId
     * @returns GetPatientEventLogsResponse
     * @throws ApiError
     */
    public patientControllerv2GetPatientEventLogs(
        patientId: number,
    ): Observable<GetPatientEventLogsResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/patients/{patientId}/history',
            path: {
                'patientId': patientId,
            },
        });
    }
}
